/**
 * Formats text by converting to lowercase and replacing Turkish characters with their Latin equivalents
 * @param {string} val - The input string to format
 * @returns {string} The formatted string with Turkish characters replaced
 */
export const customSearchTextFormatter = (val) => {
    if (val === undefined || val === null || val == "")
        return val;
  
    return val.toLowerCase()
              .replaceAll("ç", "c")
              .replaceAll("ğ", "g")
              .replaceAll("ı", "i")
              .replaceAll("i̇", "i")  // Normalized i with dot
              .replaceAll("ö", "o")
              .replaceAll("ş", "s")
              .replaceAll("ü", "u")
              .normalize("NFD")     // Decompose characters
              .replaceAll("\u0307", "") // Remove combining dot above
              .normalize("NFC");    // Recompose characters
  }